// client/src/pages/datasets/DataDocList.js
import React, { useMemo, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SmartDataTable from "../../components/SmartDataTable";
import { useOrg } from "../orgs/org-context";

export default function DataDocList() {
  const navigate = useNavigate();
  const { activeOrgId, activeOrg } = useOrg();
  const [tableKey, setTableKey] = useState(0);

  const orgId =
    activeOrgId ||
    activeOrg?._id ||
    (typeof window !== "undefined" && localStorage.getItem("activeOrgId")) ||
    "none";

  // Remount table when org changes (forces fresh fetch)
  useEffect(() => setTableKey((k) => k + 1), [orgId]);

  const columns = useMemo(
    () => [
      { label: "", type: "count", value: "__count", width: "48px", align: "center" },
      { label: "Name", value: "name", search: "name", width: "240px" },
      {
        label: "Description",
        value: "description",
        search: "description",
        type: "render",
        width: "360px",
        render: (row) => (
          <div
            style={{
              maxWidth: 360,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            title={row.description || ""}
          >
            {row.description || ""}
          </div>
        ),
      },
      {
        label: "Updated",
        value: "updatedAt",
        width: "180px",
        type: "render",
        render: (r) => (r.updatedAt ? new Date(r.updatedAt).toLocaleString() : ""),
      },
    ],
    []
  );

  // 🔹 Single Production-focused action
  const buttons = [
    {
      label: "View Data Records",
      color: "green",
      action: "/production/data-records/{_id}",
    },
  ];

  return (
    <div className="datatable-page">
      {/* Title bar */}
      <div
        className="datatable-header-row"
        style={{ justifyContent: "space-between" }}
      >
        <div style={{ fontSize: 18, fontWeight: 700, paddingLeft: 20 }}>
          Data Records
        </div>
      </div>

      <SmartDataTable
        key={`datasets-${orgId}-${tableKey}`}
        config={{
          columns,
          queryName: "/datasets/list",
          pageSize: 20,
          buttons,

          // No delete behavior from this list anymore
          deletePathTemplate: null,
          deleteMethod: null,

          headerActions: (
            <button
              className="btn-green add-new-button"
              onClick={() => navigate("/datasets/add")}
            >
              Add New Project
            </button>
          ),
        }}
      />
    </div>
  );
}
